module.exports = __webpack_public_path__ + "img/map-warning.22167372.svg";